import hcAxios from 'core/utils/hcAxios'
import { TResponse } from 'core/service/hcResponse'
// 充提币相关接口
enum API {
  // 分页查询其他记录
  FinanceOtherLogList = '/hk-web/finance/other/log/list',
  // validateAddress
  CapitalValidateAddress = '/hk-web/capital/validateAddress',
  // withdrawAddressCoin
  CapitalWithdrawAddressCoin = '/hk-web/capital/withdraw_address_coin',
  // 虚拟币提现申请前校验
  CapitalWithdrawCheck = '/hk-web/capital/withdrawCheck',
  // 财务日志个人币种
  FinanceOwnCointypeList = '/hk-web/finance/own/cointype/list',
  // getSystemCoinTypeList
  CapitalGetSystemCoinTypeList = '/hk-web/capital/getSystemCoinTypeList',
  // 查询符合地址类型的网络
  CapitalGetNetworkByAddr = '/hk-web/capital/getNetworkByAddr',
  // 根据币种id和地址查询提现地址
  CapitalCreateWithdrawAddress1659664748250 = '/hk-web/capital/create_withdraw_address_1659664748250',
  // getWithdrawAddress
  CapitalQueryWithdrawAddress = '/hk-web/capital/query_withdraw_address',
  // 分页查询合约邀请返佣记录
  FinanceContractCommissionLogList = '/hk-web/finance/contract_commission/log/list',
  // 分页统计合约邀请返佣记录
  FinanceContractCommissionSumList = '/hk-web/finance/contract_commission/sum/list',
  // 获取选中充币地址
  RechargeCoinAddress = '/hk-web/recharge/coin_address',
  // 新增虚拟币充值地址
  RechargeAddressCreate = '/hk-web/recharge/address/create',
  // 获取充币地址列表
  RechargeAddressList = '/hk-web/recharge/address/list',
  // 编辑充币地址名称
  RechargeAddressRemark = '/hk-web/recharge/address/remark',
  // 选用当前充币地址
  RechargeAddressSelected = '/hk-web/recharge/address/selected',
  // 内部转账转账前校验
  CapitalTransferPrecheck = '/hk-web/capital/transfer/precheck',
  // 内部转账提交(包括4项验证)
  CapitalTransferSubmit = '/hk-web/capital/transfer/submit',
  // 虚拟币提现申请前校验V1
  V1CapitalWithdrawCheck = '/hk-web/v1/capital/withdrawCheck',
  // 分页根据类型查询其他记录
  FinanceOtherByTypeLogList = '/hk-web/finance/other_by_type/log/list',
  // 查询支持通用提现地址的网络列表
  CapitalUniversalAddressNetworks = '/hk-web/capital/universal_address/networks',
  // 编辑提现地址设置
  CapitalWithdrawEditAddressSetting = '/hk-web/capital/withdraw/edit_address_setting',
  // 查询提现地址设置
  CapitalWithdrawGetAddressSetting = '/hk-web/capital/withdraw/get_address_setting',
  // 查询最近充提记录列表
  FinanceRechargeWithdrawList = '/hk-web/finance/recharge_withdraw/list',
  // 编辑提现地址设置
  TestCapitalWithdrawEditAddressSetting = '/hk-web/test/capital/withdraw/edit_address_setting',
  // 根据币种查询提币地址
  V3CapitalListWithdrawAddress = '/hk-web/v3/capital/list_withdraw_address',
  // 地址簿分页查询查询提现地址
  CapitalWithdrawAddressList = '/hk-web/capital/withdraw_address/list',
  // 编辑提现地址备注
  CapitalWithdrawAddressRemarkEdit = '/hk-web/capital/withdraw_address/remark_edit',
  // 分页查询空投(startup分发、startup认购)记录
  FinanceAirdropLogList = '/hk-web/finance/airdrop/log/list',
  // 查询用户钱包划转记录
  FinanceTransferHistoryList = '/hk-web/finance/transfer/history/list',
  // 资金划转类型列表
  WalletTransferTypes = '/hk-web/wallet/transfer/types',
  // 查询划转账户类型
  TransferGetType = '/hk-web/transfer/getType',
  // 查询所有账户详情
  WalletTransferInfos = '/hk-web/wallet/transfer/infos',
  // 资金划转类型列表V1
  V1WalletTransferTypes = '/hk-web/v1/wallet/transfer/types',
  // 分页查询充币记录
  FinanceRechargeLogList = '/hk-web/finance/recharge/log/list',
  // 分页查询划转记录
  FinanceTransferLogList = '/hk-web/finance/transfer/log/list',
  // 分页查询提币记录
  FinanceWithdrawLogList = '/hk-web/finance/withdraw/log/list',
  // 分页查询提币地址
  V2CapitalListWithdrawAddress = '/hk-web/v2/capital/list_withdraw_address',
  // createWithdrawAddress
  CapitalCreateWithdrawAddress = '/hk-web/capital/create_withdraw_address',
  // 提币撤销
  WithdrawCancel = '/hk-web/withdraw/cancel',
  // 提币地址校验
  V2CapitalValidateAddress = '/hk-web/v2/capital/validateAddress',
  // 删除提币地址
  V2CapitalRemoveWithdrawAddress = '/hk-web/v2/capital/remove_withdraw_address',
  // 获取提币所需参数
  V2CapitalCoinWithdrawInfo = '/hk-web/v2/capital/coin_withdraw_info',
  // 虚拟币提现申请(包括4项验证)
  CapitalWithdraw = '/hk-web/capital/withdraw',
  // 查询可提现币种信息
  ListWithdrawCoin = '/hk-web/list_withdraw_coin',
  // 获取可划转币种列表
  TransferInfo = '/hk-web/transfer/info',
  // 查询用户钱包信息
  WalletInfo = '/hk-web/wallet/info',
}
export type TPostCapitalQueryWithdrawAddressParams = {
  coinId: number
  withdrawaddress: string
}
export type TPostCapitalQueryWithdrawAddressResponse = TResponse<string>
export const postCapitalQueryWithdrawAddress = (params?: TPostCapitalQueryWithdrawAddressParams) => {
  return hcAxios.post<TPostCapitalQueryWithdrawAddressResponse>(API.CapitalQueryWithdrawAddress, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostRechargeCoinAddressParams = {
  symbol?: number // 币种id
}
export type TPostRechargeCoinAddressResponse = TResponse<{
  fadderess?: string
  fcoinid?: number
  fcreatetime?: number
  fid?: number
  fuid?: number
  isUseMemo?: boolean
  rechargeWarnWord?: string
  selected?: boolean
}>
export const postRechargeCoinAddress = (params?: TPostRechargeCoinAddressParams) => {
  return hcAxios.post<TPostRechargeCoinAddressResponse>(API.RechargeCoinAddress, params, {
    options: {
      signature: 'decrypted',
      // disableErrorCodeResponseHandler: true,
    },
  })
}

export type TGetRechargeAddressCreateParams = {
  symbol: number // 币种id
}
export type TGetRechargeAddressCreateResponse = TResponse<{
  symbol?: number // 币种id
}>
export const postRechargeAddressCreate = (params?: TGetRechargeAddressCreateParams) => {
  return hcAxios.post<TGetRechargeAddressCreateResponse>(API.RechargeAddressCreate, params, {
    options: {
      signature: 'decrypted',
      // disableErrorCodeResponseHandler: true,
    },
  })
}

export type TPostRechargeAddressListParams = {
  symbol?: number // 币种id
  contentType?: number
  signature?: string
}
export type TPostRechargeAddressListResponse = TResponse<
  {
    fid: number // 主键ID
    fcoinid: number // 虚拟币ID
    fadderess?: string // 虚拟币地址
    memo?: string // 地址标签
    rechargeWarnWord?: string // 充值提示语
    fcreatetime: number // 创建时间
    isUseMemo?: boolean // 是否使用地址标签
    fshortname?: string // 币种名称
    selected?: boolean // 是否当前选用 0-否 1-是
    remark?: string // 地址名称
  }[]
>
export const postRechargeAddressList = (params?: TPostRechargeAddressListParams) => {
  return hcAxios.post<TPostRechargeAddressListResponse>(API.RechargeAddressList, params, {
    options: {
      signature: 'decrypted',
      disableErrorCodeResponseHandler: true,
    },
  })
}

export type TPostCapitalTransferPrecheckParams = {
  address?: string // 转账信息 邮箱 手机号 uid
  addressType?: number // 转账地址类型 1-邮箱 2-手机号码 3-UID
  amount?: string // 提现数量
  areaCode?: string // 手机号码区号
  coinId?: number // 币种id
}
export type TPostCapitalTransferPrecheckResponse = TResponse<{
  amountInCny?: string // 数量折合CNY
  transferUserId?: number // 收款用户ID
}>
export const postCapitalTransferPrecheck = (params?: TPostCapitalTransferPrecheckParams) => {
  return hcAxios.post<TPostCapitalTransferPrecheckResponse>(API.CapitalTransferPrecheck, params, {
    options: {
      disableErrorCodeResponseHandler: true,
    },
  })
}

export type TPostCapitalTransferSubmitParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalTransferSubmitResponse = TResponse<{
  address?: string // 转账信息 邮箱 手机号 uid
  amount?: string // 提现数量
  areaCode?: string // 手机号码区号
  remark?: string // 备注
}>
export const postCapitalTransferSubmit = (params?: TPostCapitalTransferSubmitParams) => {
  return hcAxios.post<TPostCapitalTransferSubmitResponse>(API.CapitalTransferSubmit, params, {
    options: {
      signature: true,
    },
  })
}

export type TPostV3CapitalListWithdrawAddressParams = {
  coinId: number
}
export type TPostV3CapitalListWithdrawAddressResponse = TResponse<{
  newAddressLockNum: number // 新地址锁定数量
  list: {
    addressType: number
    chainName: string
    fadderess: string
    fcoinid: number
    fcreatetime: number
    fid: number
    fremark: string
    fuid: number
    init: boolean
    isCollectFee: boolean
    isVerified: boolean
    isWithdraw: boolean
    shortName: string
    signature: string
    status: number
    transferMode: number
    universalType: boolean
    version: number
    webLogo: string
    memo?: string
  }[]
}>
export const postV3CapitalListWithdrawAddress = (params?: TPostV3CapitalListWithdrawAddressParams) => {
  return hcAxios.post<TPostV3CapitalListWithdrawAddressResponse>(API.V3CapitalListWithdrawAddress, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostCapitalWithdrawParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
}
export type TPostCapitalWithdrawResponse = TResponse<{
  address?: string // 提现地址
  addressRemark?: string // 地址备注
  amount?: string // 提现数量
  fee?: string // 手续费
  isVerified?: number // 提币是否免认证 0-否 1-是
  memo?: string // 地址标签
  networkName?: string // 主网
}>
export const postCapitalWithdraw = (params?: TPostCapitalWithdrawParams) => {
  return hcAxios.post<TPostCapitalWithdrawResponse>(API.CapitalWithdraw, params, {
    options: {
      signature: true,
    },
  })
}

export type TPostCapitalWithdrawEditAddressSettingParams = {
  phoneCode?: string
  emailCode?: string
  googleCode?: string
  addressWhitelist?: 0 | 1
  newAddressLock?: 0 | 1
  operateType?: string // 操作类型
}
export type TPostCapitalWithdrawEditAddressSettingResponse = TResponse<string>
export const postCapitalWithdrawEditAddressSetting = (params?: TPostCapitalWithdrawEditAddressSettingParams) => {
  return hcAxios.post<TPostCapitalWithdrawEditAddressSettingResponse>(API.CapitalWithdrawEditAddressSetting, params, {
    options: {
      signature: true,
    },
  })
}

export type TPostCapitalWithdrawAddressListParams = {
  addressMerge: number
  coinId?: number // 币种id
  universalType?: boolean // 是否为通用地址 false-否 true-是
  pageNum?: number // 页码
  pageSize?: number // 每页条数
  memo?: string // 地址标签
}
export type TPostCapitalWithdrawAddressListResponse = TResponse<{
  newAddressLockNum?: number // 新地址锁定数量
  list?: {
    fid?: number // 主键ID
    fcoinid?: number // 虚拟币ID
    status?: number // 状态 1启用 2禁用
    isWithdraw?: boolean // 是否提现
    fadderess?: string // 虚拟币地址
    fcreatetime?: number // 创建时间
    fremark?: string // 备注
    memo?: any // 地址标签
    webLogo?: string // WEB站LOGO
    shortName?: string // 简称
    chainName?: string // 链名称
    isVerified?: boolean // 是否免认证 false-否 true-是
    addressLockedUntil?: any // 新地址提现锁定截止时间戳，null时表示不锁定
    universalType?: boolean // 是否为通用地址 false-否 true-是
    transferMode?: number // 转账模式 1-链上提现 2-内部转账
    addressType?: number // 地址类型 0-链上地址 1-邮箱 2-手机号码 3-UID
    areaCode?: string // 手机号码区号
  }[]
}>
export const postCapitalWithdrawAddressList = (params?: TPostCapitalWithdrawAddressListParams) => {
  return hcAxios.post<TPostCapitalWithdrawAddressListResponse>(API.CapitalWithdrawAddressList, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TPostCapitalCreateWithdrawAddressParams = {
  bizData?: string // 加密后的业务数据
  randomIv?: string // 随机向量
  randomKey?: string // 随机密钥
  signature?: string // 签名串
  timestamp?: number // 时间戳
} & any
export type TPostCapitalCreateWithdrawAddressResponse = TResponse<any>
export const postCapitalCreateWithdrawAddress = (params?: TPostCapitalCreateWithdrawAddressParams) => {
  return hcAxios.post<TPostCapitalCreateWithdrawAddressResponse>(API.CapitalCreateWithdrawAddress, params, {
    options: {
      signature: 'decrypted',
    },
  })
}

export type TGetV2CapitalValidateAddressParams = {
  AccessKeyId?: string // 签名AccessKeyId
  SignatureVersion?: string // 签名SignatureVersion
  SignatureMethod?: string // 签名SignatureMethod
  Timestamp?: string // 签名Timestamp
  Signature?: string // 签名Signature
  tradePwd?: string // 资金密码
  googleCode?: string // google验证码
  phoneCode?: string // 手机验证码
  emailCode?: string // 邮箱验证码
  coinId?: number // 币种id
  withdrawAddr?: string // 提币地址
  memo?: string // 地址标签
  remark?: string // 地址备注
  address?: string
  scene?: number
}
export type TGetV2CapitalValidateAddressResponse = TResponse<{
  platformTransfer?: boolean // 仅当code为200时有效(提示信息，非错误)，是否为平台互转，true为平台互转
}>

export const getV2CapitalValidateAddress = (params?: TGetV2CapitalValidateAddressParams) => {
  return hcAxios.get<TGetV2CapitalValidateAddressResponse>(API.V2CapitalValidateAddress, {
    params,
    options: {
      disableErrorCodeResponseHandler: true,
    },
  })
}
